import axios from 'axios';

const API = `${process.env.REACT_APP_API_BASE_URL}/admin`;

export const getCommunications = async () => (await axios.get(`${API}/communications`)).data;
export const saveTemplate = async (channel, event, template) => (await axios.put(`${API}/communications/${channel}/${event}`, template)).data.template;
export const resetTemplate = async (channel, event) => (await axios.post(`${API}/communications/${channel}/${event}/reset`)).data.template;
export const testTemplate = async (channel, event, payload) => (await axios.post(`${API}/communications/${channel}/${event}/test`, payload)).data;
export const previewEmail = async (event, template) => (await axios.post(`${API}/communications/email/${event}/preview`, template)).data;
export const getMessageLog = async (params = {}) => (await axios.get(`${API}/messages`, { params })).data.logs;
export const getOrderWhatsapp = async (orderId, event) => (await axios.get(`${API}/orders/${orderId}/whatsapp`, { params: { event } })).data;

// Popup blockers only allow windows opened directly in a tap, so open first, then point it at WhatsApp
export const openWhatsapp = async (getLink) => {
    const win = window.open('', '_blank');
    try {
        const link = await getLink();
        if (win) win.location.href = link; else window.location.href = link;
    } catch (e) {
        win?.close();
        throw e;
    }
};
